const state = {
  aegis: null,
    isTimeout: null
};

const getters = {};

const mutations = {
    SET_AEGIS(state, aegis) {
        state.aegis = aegis;
    },
    setTimeStatus: (state, payload) => {
        state.isTimeout = payload;
    }
};

const actions = {
    setTimeStatus(context, payload) {
        context.commit('setTimeStatus', payload);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
